export const checkRoles = (roles) => roles.includes("family");
